// src/jira/field-scheme/types.ts
var JiraFieldSchemeAriResourceOwner = "jira", JiraFieldSchemeAriResourceType = "field-scheme";

export {
  JiraFieldSchemeAriResourceOwner,
  JiraFieldSchemeAriResourceType
};
